import { Box, Stack, Typography } from "@mui/material";

import { QA_THREAD_BORDER_GREY } from "constants/index";

import { AnswerAuthor } from "../Authors";

import type { ShipmentAnswerCarrierView } from "types/shipments/qa";

interface AnswerProps {
  answer: ShipmentAnswerCarrierView | null;
  isPartnerShipment: boolean;
}

export function Answer(props: AnswerProps) {
  const { answer, isPartnerShipment } = props;

  if (answer == null) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignContent="flex-start"
      ml=".5rem"
      alignItems="flex-end"
      mb="1rem"
    >
      <Box
        sx={{
          border: `1px solid ${QA_THREAD_BORDER_GREY}`,
          height: "5rem",
          mr: ".5rem",
        }}
      />
      <Stack direction="column">
        <AnswerAuthor
          isPartnerShipment={isPartnerShipment}
          firstName={answer.role?.user?.first_name}
          timestamp={answer.created_at}
        />
        <Typography
          variant="h5"
          sx={{
            whiteSpace: "normal",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
            maxWidth: "100%",
          }}
        >
          {answer.text}
        </Typography>
      </Stack>
    </Stack>
  );
}
